module.exports = __webpack_public_path__ + "img/closeIconHover.dfc30530.svg";